<template>
    <div>
        <div name="tabs" class="tabs-layout" style="position: relative" v-if="showTab">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="按资产查看" name="asset"></el-tab-pane>
                <el-tab-pane label="按公司查看" name="realCom"></el-tab-pane>
            </el-tabs>
            <!--<div class="swb-btn swb-btn-small" @click="toSelect()" style="position: absolute;top: 6px;right: 58px">选择</div>-->
            <!--<div class="swb-btn swb-btn-small" @click="toQueryDeprPlan()" style="position: absolute;top: 6px;right: 0">查询</div>-->
        </div>

        <div name="simple_form" class="simple-form flex col-4">
            <div class="form-group center" v-if="activeName == 'asset'">
                <div class="form-label">
                    <label>资产编号</label>
                </div>
                <div class="form-value">
                    <!--<span>{{reprotInfo.innerCode || '无'}}</span>-->
                    <el-input v-model="reprotInfo.innerCode" class="bottom-line width-1x" disabled="true"></el-input>
                    <a class="swb-btn swb-btn-link" @click="toSelect()" v-if="showTab">选择</a>
                </div>
            </div>
            <div class="form-group center" v-if="activeName == 'asset'">
                <div class="form-label">
                    <label>资产分类</label>
                </div>
                <div class="form-value">
                    <span>{{reprotInfo.innerDevcCatName || '无'}}</span>
                </div>
            </div>
            <div class="form-group center" v-if="activeName == 'asset'">
                <div class="form-label">
                    <label>财务类别</label>
                </div>
                <div class="form-value">
                    <span>{{reprotInfo.assetKindName || '无'}}</span>
                </div>
            </div>
            <div class="form-group center" v-if="activeName == 'realCom'">
                <div class="form-label">
                    <label>公司编码</label>
                </div>
                <div class="form-value">
                    <!--<span>{{reprotInfo.retailerRealComCode || '无'}}</span>-->
                    <el-input v-model="reprotInfo.retailerRealComCode" class="bottom-line width-1x" disabled="true"></el-input>
                    <a class="swb-btn swb-btn-link" @click="toSelect()">选择</a>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>公司名称</label>
                </div>
                <div class="form-value">
                    <span>{{reprotInfo.retailerRealComName || '无'}}</span>
                </div>
            </div>
            <div class="form-group center" v-if="activeName == 'asset'">
                <div class="form-label">
                    <label>利润中心</label>
                </div>
                <div class="form-value">
                    <span>{{reprotInfo.prftCenterCode || '无'}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>累计折旧(元)</label>
                </div>
                <div class="form-value">
                    <span>{{parseFloat(reprotInfo.aggtDeprWorth || 0).toFixed(2)}}</span>
                </div>
            </div>
            <div class="form-group center" v-if="activeName == 'asset'">
                <div class="form-label">
                    <label>已计提期数</label>
                </div>
                <div class="form-value">
                    <span>{{reprotInfo.deprSeqNo || 0}}</span>
                </div>
            </div>
            <div class="form-group center" v-if="activeName == 'asset'">
                <div class="form-label">
                    <label>剩余期数</label>
                </div>
                <div class="form-value">
                    <span>{{reprotInfo.leftMonths || 0}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>年度</label>
                </div>
                <div class="form-value">
                    <el-select v-model="reprotInfo.year" placeholder="请选择" @change="yearChange()">
                        <el-option v-for="item in yearList" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="form-group center" v-if="activeName == 'asset'">
                <div class="form-label">
                    <label>计提状态</label>
                </div>
                <div class="form-value">
                    <el-select v-model="reprotInfo.extracted" placeholder="请选择">
                        <el-option v-for="item in extractedList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label></label>
                </div>
                <div class="form-value">
                    <div class="swb-btn swb-btn-small" @click="toQueryDeprPlan()">查询</div>
                </div>
            </div>
        </div>
        <div class="simple-row" name="btns">
            <div class="left">
                <div class="swb-btn swb-btn-small" @click="doExport">
                    <span>导出</span>
                </div>
            </div>
            <div class="right">
                <div class="swb-btn swb-btn-small swb-btn-primary" @click="doRelDeprTest" v-if="checkActionPerm('re_depr_test')">
                    <span>重新预测</span>
                </div>
            </div>
        </div>
        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="theTableHeight" :pageNoChangeHandler="pageNoChangeHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher, showPageRangeSelDlg } from '../../app.vues'
    import { getDefaultPageSizes, getDefaultDownloadPageSize } from '../../app.conf'
    import { checkUserActionPerm } from '../index'
    import { showGrpDownloadDlg } from '../ctrl/dialog'
    import { openRealComTreeDlg } from '../orgStruct/selectDlg'
    import { showDevcSelectDlg } from '../devc/selectDlg'

    import assetFiscalApi from '../../api/assetFiscal';

    export default {
        name: 'swb-asset-depr-plan-report',
        path: '/asset/depr/plan/report',
        desc: '折旧计划报表',
        props: {
            showTab: {
                type: Boolean,
                default: true
            },
            assetInfo: {
                type: Object,
                default: function () {
                    return {};
                }
            }
        },
        data: function () {
            return {
                // 分页信息
                pageNumber: 1,
                totalCount: 0,
                pageSize: 12,
                pageSizes: [12],
                lastPageNumber: null,
                //
                confKey: 'swb-asset-depr-plan-report',
                theTableHeight: 520,
                //
                needPager: false, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）
                //
                btnColName: '',//操作列名称（如果不设置就不显示操作列）
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 200,//操作列宽度（默认：100）
                btnColFixed: true, //操作列是否固定
                // 过滤信息
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                assetTypeMap: getEnumMap("assetType", "value2text"),
                // 其他信息
                activeName: 'asset',
                oldActiveName: 'asset',
                exportFilter: {},
                reprotInfo: {
                    extracted: null
                },
                currYear: parseInt(new Date().format('yyyy')),
                oldYear: parseInt(new Date().format('yyyy')),
                yearList: [],
                isDialog: false // 是否弹框
            }
        },
        created: function () {
//            this.pageSize = this.pageSizes.first();
            // 执行状态
            let dataList = [{"value": null, "label": "- 全部 -"}];
            dataList.push({"value": true, "label": "已计提"});
            dataList.push({"value": false, "label": "未计提"});
            this.extractedList = Utils.merge([], dataList);
            //
            let assetInfo = this.assetInfo || {};
            if(!Utils.isNoB(assetInfo) && assetInfo.id > 0) {
                // 说明是弹框
                this.isDialog = true;
                //
                let reprotInfo = {};
                reprotInfo.assetType = assetInfo.assetType;
                reprotInfo.deviceXId = assetInfo.id;
                reprotInfo.innerCode = assetInfo.innerCode;
                reprotInfo.innerDevcCatName = assetInfo.innerDevcCatName;
                reprotInfo.assetKindName = assetInfo.assetKindName;
                reprotInfo.retailerRealComId = assetInfo.retailerRealComId;
                reprotInfo.retailerRealComName = assetInfo.retailerRealComName;
                reprotInfo.prftCenterCode = assetInfo.prftCenterCode;
                reprotInfo.aggtDeprWorth = assetInfo.aggtDeprWorth;
                reprotInfo.leftMonths = assetInfo.leftMonths;
                let deprSeqNo = (assetInfo.durableLife || 0) - (assetInfo.leftMonths || 0);
                reprotInfo.deprSeqNo = deprSeqNo < 0 ? 0 : deprSeqNo;
                reprotInfo.extracted = null;
                let yearList = assetInfo.yearList || [];
                let len = yearList.length || 0;
                if(len > 0) {
                    let year = yearList[len - 1];
                    if(year > this.currYear) {
                        reprotInfo.year = this.currYear;
                    } else {
                        reprotInfo.year = year;
                    }
                }
                //
                this.reprotInfo = Utils.merge({}, reprotInfo);
                //
                this.yearList = Utils.merge([], yearList);
            }
        },
        mounted() {
            let self = this;
            if(!Utils.isTrue(self.isDialog)) {
                //注册domSizeWatcher
                let thisEl = $(this.$el);
                $(this.$el).addClass('overflow-hidden');
                //
                let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
                domSizeWatcher.setBaseEl(thisEl);
                domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                    //  根据新主元素的内容大小，调整表格高度
                    self.theTableHeight = height;
                });
                //domSizeWatcher.setHrEls();
                domSizeWatcher.setVtEls(thisEl.find('[name="tabs"], [name="simple_form"], [name="btns"]'));
                domSizeWatcher.start(500);
            }
            //
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
            },
            //
            initResultTable() {
                let self = this;
                let resultTable = this.$refs['result_table'];
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'assetTypeText': function (row, colName, colValue, rowIndex) {
                        return '<span>' + self.assetTypeMap[row.assetType] + '</span>';
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        return [];
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                    }
                });
            },
            // 页签切换
            handleClick(tab, event) {
                let oldActiveName = this.oldActiveName;
                if(oldActiveName != tab.name) {
                    this.reprotInfo = {
                        extracted: null,
                        year: this.currYear
                    };
                    // 清空列表
                    this.renderTable([], {});
                    //
                    if(oldActiveName == 'asset') {
                        let yearList = [];
                        let date = new Date();
                        let year = parseInt(date.format('yyyy'));
                        yearList.push(year);
                        let nextYear = parseInt(date.addYears(1).format('yyyy'));
                        yearList.push(nextYear);
                        this.yearList = Utils.merge([], yearList);
                    } else {
                        this.yearList = [];
                    }
                    this.oldActiveName = tab.name;
                }
            },
            // 年度变化事件
            yearChange: function () {
                let oldYear = this.oldYear;
                let reprotInfo = this.reprotInfo || {};
                let year = reprotInfo.year;
                if(!Utils.isNoB(year) && year != oldYear) {
                    this.renderTable([], {});
                }
                this.oldYear = year;
            },
            // 选择
            toSelect: function () {
                let self = this;
                let reprotInfo = self.reprotInfo || {};
                if(this.activeName == 'asset') {
                    // 选择资产
                    let deviceXId = reprotInfo.deviceXId;
                    let deviceXIds = [];
                    if(!Utils.isNoB(deviceXId)) {
                        deviceXIds.push(deviceXId);
                    }
                    //
                    let filter = {};
                    filter.scrapped = 0;
                    filter.cleared = false;
                    filter.deprable = true;
                    filter.deprFlag = true;
                    filter.unFilterAuthx = true;
                    filter.useRealQuery = true;
                    let params = {
                        filter: filter,
                        devcBizClolumType: getEnumInfoWith("devcBizClolumType", "name", "DefDlg").name,   // 通用
                        initSelectIds: deviceXIds,
                        selectAll: true,
                        checkBox: false
                    };
                    showDevcSelectDlg(params, function (assetInfo) {
                        //
                        assetInfo = assetInfo || {};
                        reprotInfo.assetType = assetInfo.assetType;
                        reprotInfo.deviceXId = assetInfo.id;
                        reprotInfo.innerCode = assetInfo.innerCode;
                        reprotInfo.innerDevcCatName = assetInfo.innerDevcCatName;
                        reprotInfo.assetKindName = assetInfo.assetKindName;
                        reprotInfo.retailerRealComId = assetInfo.retailerRealComId;
                        reprotInfo.retailerRealComName = assetInfo.retailerRealComName;
                        reprotInfo.prftCenterCode = assetInfo.prftCenterCode;
                        reprotInfo.aggtDeprWorth = assetInfo.aggtDeprWorth;
                        //
                        let yearList = assetInfo.yearList || [];
                        if(deviceXId != assetInfo.id) {
                            reprotInfo.leftMonths = assetInfo.leftMonths;
                            let deprSeqNo = (assetInfo.durableLife || 0) - (assetInfo.leftMonths || 0);
                            reprotInfo.deprSeqNo = deprSeqNo < 0 ? 0 : deprSeqNo;
                            reprotInfo.year = null;
                            reprotInfo.extracted = null;
                            let len = yearList.length || 0;
                            if(len > 0) {
                                let year = yearList[len - 1];
                                if(year > self.currYear) {
                                    reprotInfo.year = self.currYear;
                                } else {
                                    reprotInfo.year = year;
                                }
                            }
                            //
                            self.totalCount = 0;
                            self.renderTable([], {});
                        }
                        self.reprotInfo = Utils.merge({}, reprotInfo);
                        // 组装年份列表
                        if(deviceXId != assetInfo.id) {
                            self.yearList = Utils.merge([], yearList);
                            self.renderTable([], {});
                        }
                    });
                } else {
                    let realComId = reprotInfo.retailerRealComId;
                    // 选择实体公司
                    let params = {
                        isRadio: true,
                        dblclickFlag: true,
                        realComDefFirst: false,
                        prftFlag: false,
                        deprFlag: true,
                        selectRealComId: realComId
                    };
                    openRealComTreeDlg(params, function (realCom, theDlg) {
                        theDlg.close();
                        //
                        reprotInfo.retailerRealComId = realCom.id;
                        reprotInfo.retailerRealComName = realCom.name;
                        reprotInfo.retailerRealComCode = realCom.code;
                        reprotInfo.aggtDeprWorth = realCom.aggtDeprWorth;
                        if(realComId != realCom.id) {
                            reprotInfo.year = self.currYear;
                            reprotInfo.extracted = null;
                            //
                            self.totalCount = 0;
                            self.renderTable([], {});
                        }
                        self.reprotInfo = Utils.merge({}, reprotInfo);
                    });
                }
            },
            // 查询折旧计划
            toQueryDeprPlan: function () {
                let reprotInfo = this.reprotInfo || {};
                let params = {};
                if(this.activeName == 'asset') {
                    if(Utils.isNoB(reprotInfo.deviceXId)) {
                        MsgBox.warning("请选择资产！");
                        return;
                    }
                    params.deviceXId = reprotInfo.deviceXId;
                    params.assetType = reprotInfo.assetType;
                    params.realComFlag = false;
                } else {
                    // 实体公司
                    if(Utils.isNoB(reprotInfo.retailerRealComId)) {
                        MsgBox.warning("请选择公司！");
                        return;
                    }
                    params.retailerRealComId = reprotInfo.retailerRealComId;
                    params.realComFlag = true;
                }
                if(Utils.isNoB(reprotInfo.year)) {
                    MsgBox.warning("请选择要查询的年度！");
                    return;
                }
                params.year = reprotInfo.year;
                params.extracted = reprotInfo.extracted;
                //
                let queryModel = this.queryModel;
                queryModel.filterItems = Utils.merge({}, params);
                this.queryModel = Utils.merge({}, queryModel);
                //
                this.pageNoChangeHandler(1, this.pageSize);
            },
            // 重新预测
            doRelDeprTest: function () {
                let self = this;
                if(!Utils.repeatChecker.isValidFor("doRelDeprTest", 1000)) {
                    return;
                }
                let reprotInfo = this.reprotInfo || {};
                let params = {};
                if(this.activeName == 'asset') {
                    if(Utils.isNoB(reprotInfo.deviceXId)) {
                        MsgBox.warning("请选择资产！");
                        return;
                    }
                    params.deviceXId = reprotInfo.deviceXId;
                    params.assetType = reprotInfo.assetType;
                    params.realComFlag = false;
                } else {
                    // 实体公司
                    if(Utils.isNoB(reprotInfo.retailerRealComId)) {
                        MsgBox.warning("请选择公司！");
                        return;
                    }
                    params.retailerRealComId = reprotInfo.retailerRealComId;
                    params.realComFlag = true;
                }
                if(Utils.isNoB(reprotInfo.year)) {
                    MsgBox.warning("请选择要重新预测的年度！");
                    return;
                }
                //
                this.$confirm('确定要重新预测吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    //
                    params.year = reprotInfo.year;
                    params.extracted = reprotInfo.extracted;
                    params.relDeprTest = true;
                    //
                    let queryModel = self.queryModel;
                    queryModel.filterItems = Utils.merge({}, params);
                    self.queryModel = Utils.merge({}, queryModel);
                    //
                    self.pageNoChangeHandler(1, self.pageSize);
                }).catch(function () {
                });
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                this.lastPageNumber = null;
                //
                this.getAssetDeprPlanItemList();
            },
            renderTable(rows, pagination) {
                let resultTable = this.$refs.result_table;
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            // 查询折旧计划
            getAssetDeprPlanItemList(){
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                if(!Utils.isNoB(this.formId)) {
                    filterItems.formId = this.formId;
                }
                if(!Utils.isNoB(this.extracted)) {
                    filterItems.extracted = this.extracted;
                }
                if(!Utils.isNoB(this.onlyExtraDepr)) {
                    filterItems.onlyExtraDepr = this.onlyExtraDepr;
                }
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                self.exportFilter = filterItems;
                //
                let theLoading = MsgBox.loading();
                assetFiscalApi.getAssetDeprPlanItemReportByFilter(postData, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        let assetDeprRecList = result.data.rows || [];
                        self.totalCount = result.data.pagination.totalCount;
                        self.renderTable(assetDeprRecList, result.data.pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 导出
            doExport: function () {
                let self = this;
                let pageSize = getDefaultDownloadPageSize();
                let pages = Math.ceil(self.totalCount / 2000);
                if(pages > 10) {
                    showPageRangeSelDlg("选择导出文件序号", pages, 10, this.lastPageNumber, function (ok, range) {
                        if(ok) {
                            if(range.to == pages) {
                                self.lastPageNumber = 0;
                            } else {
                                self.lastPageNumber = range.to;
                            }
                            //
                            self.exportPrintData(pageSize, range.from, range.to);
                        }
                    }, {pageSize: pageSize})
                } else {
                    self.exportPrintData(pageSize);
                }
            },
            exportPrintData(pageSize, fromPages, toPages){
                let totalCount = this.totalCount;
                let pages = Math.ceil(totalCount / pageSize);
                //
                fromPages = fromPages == null ? 1 : fromPages;
                toPages = toPages == null ? pages : toPages;
                let tableData = this.getTableData(pages, pageSize);
                //
                let url = getAppUrl("/file/export/as/excel");
                let downloadUrls = [];
                for(let i = fromPages; i <= toPages; i++) {
                    let tmpFile = {};
                    tmpFile.url = url;
                    tmpFile.post = true;
                    tmpFile.fileName = "折旧计划报表" + (pages == 1 ? '' : ("_" + (i)));
                    tmpFile.seqNo = i;
                    //
                    let data = Utils.merge({}, tableData);
                    data.pageNumber = i;
                    data.fileName = tmpFile.fileName;
                    tmpFile.data = data;
                    downloadUrls.push(tmpFile);
                }
                let title = '折旧计划-下载| 每个文件' + pageSize + '条数据';
                showGrpDownloadDlg(title, downloadUrls);
            },
            getTableData(pages, pageSize){
                let resultTable = this.$refs.result_table;
                let tableData = resultTable.getTableData(true);
                delete tableData.rows;//减少数据传输量
                //
                let rowsSrc = {};
                rowsSrc.data = this.getPostData();
                rowsSrc.url = "/asset/fiscal/asset/depr/plan/report/get";
                tableData.rowsSrc = rowsSrc;
                //
                tableData.pageSize = pageSize;
                tableData.pageCount = this.totalCount;
                tableData.pages = pages;
                return tableData;
            },
            getPostData(){
                let queryModel = this.queryModel;
                let filterItems = Utils.merge({}, this.exportFilter);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                let reprotInfo = this.reprotInfo || {};
                if(this.activeName == 'asset') {
                    filterItems.devcInnerCodeX = reprotInfo.innerCode;
                    filterItems.innerDevcCatName = reprotInfo.innerDevcCatName;
                    filterItems.assetKindNameX = reprotInfo.assetKindName;
                    filterItems.retailerRealComNameX = reprotInfo.retailerRealComName;
                    filterItems.prftCenterCodeX = reprotInfo.prftCenterCode;
                    filterItems.aggtDeprWorthX = reprotInfo.aggtDeprWorth;
                    filterItems.deprSeqNoX = reprotInfo.deprSeqNo;
                    filterItems.leftMonthsX = reprotInfo.leftMonths;
                } else {
                    filterItems.retailerRealComCodeX = reprotInfo.retailerRealComCode;
                    filterItems.retailerRealComNameX = reprotInfo.retailerRealComName;
                    filterItems.aggtDeprWorthX = reprotInfo.aggtDeprWorth;
                }
                //
                let postData = {};
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                return postData;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/assetDepr/AssetDeprPlanReport.vue